import api from './api';

/** Betriebsschließungstage of the acting organisation. */
export const getCompanyClosures = async () => {
    const res = await api.get('/CompanyClosure');
    return res.data || [];
};

/** Holiday already booked on days a closure now covers. */
export const getClosureConflicts = async () => {
    const res = await api.get('/CompanyClosure/conflicts');
    return res.data || [];
};

export const addCompanyClosure = async (closure) => {
    const res = await api.post('/CompanyClosure', closure);
    return res.data;
};

/** Patch a closure. Only the keys passed are written, so send `exception_user_ids: []` to clear
 *  the exceptions and omit the key to leave them alone. */
export const updateCompanyClosure = async (id, patch) => {
    const res = await api.patch(`/CompanyClosure/${id}`, patch);
    return res.data;
};

export const deleteCompanyClosure = async (id) => {
    const res = await api.delete(`/CompanyClosure/${id}`);
    return res.data;
};
